export const FillStar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="140" height="141" fill="none">
      <rect width="140" height="140" y=".5" fill="var(--color-primary-surface)" rx="70" />
      <g clipPath="url(#a)">
        <path
          fill="var(--color-primary-shadow)"
          d="m90.287 22.46 2.342 36.27 27.372 21.289-32.92 9.614-14.287 30.121L59.6 96.982 28.473 90.52l15.592-25.207-10.093-33.931L66.045 43.7z"
        />
        <path
          fill="var(--color-primary)"
          d="m90.829 23-1.295 33.711 14.584 11.403a21.7 21.7 0 0 0 6.515 3.504l5.656 1.885-10.587 5.77a21.4 21.4 0 0 1-4.235 1.753L84.29 86.068 73.858 118 55.924 89.933l-32.315-.489 20.03-26.48-9.541-32.234L64.41 42.433z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M20 20.5h100v100H20z" />
        </clipPath>
      </defs>
    </svg>
  )
}
